/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  CalculationResponseCollectionResponse,
  Condition,
  EntityListCreateRequest,
  EntityListHoldersResponseDataResponse,
  EntityListImportItemResponseCollectionResponse,
  EntityListImportItemsRequest,
  EntityListImportRequest,
  EntityListImportResponseDataResponse,
  EntityListImportSummariesResponseDataResponse,
  EntityListImportVerificationRequest,
  EntityListItemResponseCollectionResponse,
  EntityListItemResponseEntityListVersionItemsResponse,
  EntityListResponseCollectionResponse,
  EntityListResponseDataResponse,
  EntityListTypeName,
  EntityListTypeResponseCollectionResponse,
  EntityListUnarchivePreviewResponseDataResponse,
  EntityListUpdateRequest,
  ErrorResponse,
  Sorting,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';
export class EntityLists<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags EntityLists
   * @name EntityListsList
   * @request GET:/EntityLists
   * @response `200` `EntityListResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  entityListsList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
      type?: EntityListTypeName;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<EntityListResponseCollectionResponse, ErrorResponse>({
      path: `/EntityLists`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name CreateEntityList
   * @request POST:/EntityLists
   * @response `200` `EntityListResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createEntityList = (data: EntityListCreateRequest, params: RequestParams = {}) =>
    this.http.request<EntityListResponseDataResponse, ErrorResponse>({
      path: `/EntityLists`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetEntityList
   * @request GET:/EntityLists/{id}
   * @response `200` `EntityListResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityList = (id: number, params: RequestParams = {}) =>
    this.http.request<EntityListResponseDataResponse, ErrorResponse>({
      path: `/EntityLists/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name UpdateEntityList
   * @request PATCH:/EntityLists/{id}
   * @response `200` `EntityListResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  updateEntityList = (id: number, data: EntityListUpdateRequest, params: RequestParams = {}) =>
    this.http.request<EntityListResponseDataResponse, ErrorResponse>({
      path: `/EntityLists/${id}`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name DeleteEntityList
   * @request DELETE:/EntityLists/{id}
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteEntityList = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/EntityLists/${id}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetEntityListUnarchivePreview
   * @request GET:/EntityLists/{id}/UnarchivePreview
   * @response `200` `EntityListUnarchivePreviewResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityListUnarchivePreview = (id: number, params: RequestParams = {}) =>
    this.http.request<EntityListUnarchivePreviewResponseDataResponse, ErrorResponse>({
      path: `/EntityLists/${id}/UnarchivePreview`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetEntityListTypes
   * @request GET:/EntityLists/Types
   * @response `200` `EntityListTypeResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityListTypes = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<EntityListTypeResponseCollectionResponse, ErrorResponse>({
      path: `/EntityLists/Types`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetEntityListCalculations
   * @request GET:/EntityLists/{id}/Calculations
   * @response `200` `CalculationResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityListCalculations = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CalculationResponseCollectionResponse, ErrorResponse>({
      path: `/EntityLists/${id}/Calculations`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetEntityListHolders
   * @request GET:/EntityLists/{id}/Holders
   * @response `200` `EntityListHoldersResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityListHolders = (id: number, params: RequestParams = {}) =>
    this.http.request<EntityListHoldersResponseDataResponse, ErrorResponse>({
      path: `/EntityLists/${id}/Holders`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetLatestEntityListItems
   * @request GET:/EntityLists/{id}/Items
   * @response `200` `EntityListItemResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getLatestEntityListItems = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<EntityListItemResponseCollectionResponse, ErrorResponse>({
      path: `/EntityLists/${id}/Items`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * @description Final step of the import process. Marks related Calculations as outdated if entity list is used in them.
   *
   * @tags EntityLists
   * @name PutEntityListItems
   * @summary Step 3 of Entity List Import process - move import items to entity list
   * @request PUT:/EntityLists/{id}/Items
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putEntityListItems = (
    id: number,
    data: EntityListImportVerificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/EntityLists/${id}/Items`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetEntityListImport
   * @request GET:/EntityLists/{id}/Import
   * @response `200` `EntityListImportResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityListImport = (id: number, params: RequestParams = {}) =>
    this.http.request<EntityListImportResponseDataResponse, ErrorResponse>({
      path: `/EntityLists/${id}/Import`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name CreateEntityListImport
   * @summary Step 1 of Entity List Import process - create entity list import record
   * @request POST:/EntityLists/{id}/Import
   * @response `200` `EntityListImportResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  createEntityListImport = (
    id: number,
    data: EntityListImportRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EntityListImportResponseDataResponse, ErrorResponse>({
      path: `/EntityLists/${id}/Import`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name DeleteEntityListImport
   * @request DELETE:/EntityLists/{id}/Import
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  deleteEntityListImport = (
    id: number,
    data: EntityListImportVerificationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/EntityLists/${id}/Import`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Number of Skus to be enabled is not returned for Request lists.
   *
   * @tags EntityLists
   * @name GetEntityListImportSummary
   * @summary For each possible EntityListImportAction returns a number of items affected by that action and also number Skus that will be enabled during the import.
   * @request GET:/EntityLists/{id}/ImportSummary
   * @response `200` `EntityListImportSummariesResponseDataResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityListImportSummary = (id: number, params: RequestParams = {}) =>
    this.http.request<EntityListImportSummariesResponseDataResponse, ErrorResponse>({
      path: `/EntityLists/${id}/ImportSummary`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetEntityListImportItems
   * @request GET:/EntityLists/{id}/ImportItems
   * @response `200` `EntityListImportItemResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getEntityListImportItems = (
    id: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<EntityListImportItemResponseCollectionResponse, ErrorResponse>({
      path: `/EntityLists/${id}/ImportItems`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * @description Items are first loaded under Entity List Import created earlier (using POST /EntityLists{id}/Import) After review, call PUT /EntityLists/:id/Items to finish the import.
   *
   * @tags EntityLists
   * @name PutEntityListImportItems
   * @summary Step 2 of Entity List Import process - load items to import
   * @request PUT:/EntityLists/{id}/ImportItems
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  putEntityListImportItems = (
    id: number,
    data: EntityListImportItemsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, ErrorResponse>({
      path: `/EntityLists/${id}/ImportItems`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetVersionedEntityListItems
   * @request GET:/EntityLists/{id}/Versions/{versionId}/Items
   * @response `200` `EntityListItemResponseEntityListVersionItemsResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getVersionedEntityListItems = (
    id: number,
    versionId: number,
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<EntityListItemResponseEntityListVersionItemsResponse, ErrorResponse>({
      path: `/EntityLists/${id}/Versions/${versionId}/Items`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EntityLists
   * @name GetLatestEntityListItemsCsvFile
   * @summary Download Entity List Items as a CSV file
   * @request GET:/EntityLists/{id}/Items/Csv
   * @response `200` `void` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  getLatestEntityListItemsCsvFile = (id: number, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponse>({
      path: `/EntityLists/${id}/Items/Csv`,
      method: 'GET',
      ...params,
    });
}
